import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
// import Stepper from "@material-ui/core/Stepper";
// import Step from "@material-ui/core/Step";
// import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { languages } from "../constants/languages";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import EditDayContainer from "../containers/schedule/EditDayContainer";
import EditSportParkContainer from "../containers/schedule/EditSportParkContainer";
import EditDivisionContainer from "../containers/teams/EditDivisionContainer";
// import name1 from "../img/1name.png";
// import date2 from "../img/2date.png";
// import location3 from "../img/3location.png";
// import divisions4 from "../img/4divisions.png";
// import account5 from "../img/5account.png";
import moment from "moment-timezone";
import {
  LinearProgress,
  Paper,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import Icon from "@mdi/react";
import HelpIcon from "@material-ui/icons/Help";
// import { mdiTrophy } from "@mdi/js";
// import { mdiMapMarker } from "@mdi/js";
import { mdiEmail } from "@mdi/js";
import { mdiLock } from "@mdi/js";
import { mdiAccount } from "@mdi/js";
// import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { Link } from "react-router-dom";
import LocationAutoComplete from "./schedule/LocationAutoComplete";
import { Checkbox, FormControlLabel } from "@material-ui/core";

if (languages.getLanguage() === "nl") {
  require("moment/locale/nl");
}

if (languages.getLanguage() === "fr") {
  require("moment/locale/fr");
}

if (languages.getLanguage() === "de") {
  require("moment/locale/de");
}

if (languages.getLanguage() === "es") {
  require("moment/locale/es");
}

if (languages.getLanguage() === "pl") {
  require("moment/locale/pl");
}

const styles = (theme) => ({
  root: {
    width: "100%",
    // marginTop: 60,
    [theme.breakpoints.up("md")]: {
      height: "calc(100vh - 8px)",
    },

    // [theme.breakpoints.down("sm")]: {
    //   marginTop: 70
    // }
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  descriptionTexts: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 100,
    maxWidth: 400,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  paper: {
    maxWidth: 400,
    width: "95%",
    margin: "0px 10px 5px",
    minHeight: 500,
    // [theme.breakpoints.down("sm")]: {
    //   margin: "0 10px 5px"
    // },
    position: "relative",
    zIndex: 10,
  },
  nvd1: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  nvd2: {
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  centerContainer: {
    width: "100%",
    zIndex: 10,
    [theme.breakpoints.down("sm")]: {
      marginTop: 70,
    },
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
});

function getSteps() {
  return [
    languages.createTournament.name,
    // languages.createTournament.date,
    languages.createTournament.location,
    languages.createTournament.division,
  ];
}

function getStepContent(stepIndex, props, handleKeyDown) {
  switch (stepIndex) {
    case 0:
      return (
        <div style={{ maxWidth: 400 }}>
          {/* <div style={{ textAlign: "center" }}>
            <img src={name1} alt="" style={{ height: 120, marginBottom: 20 }} />
          </div> */}
          <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
            {languages.createTournament.newTournament}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 10, marginTop: 8 }}
          >
            {languages.createTournament.newTournamentDescription}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            margin="normal"
            label={languages.general.nameTournament}
            name="name"
            value={props.tournament.name}
            onChange={props.handleNameChange}
            onKeyDown={handleKeyDown}
            // placeholder={languages.createTournament.fillInAndPressEnter}
            // InputProps={{
            //   endAdornment: (
            //     <InputAdornment position="end">
            //       <Icon
            //         path={mdiTrophy}
            //         size={1}
            //         color="rgba(0, 0, 0, 0.54)"
            //         style={{ marginRight: 12 }}
            //       />
            //     </InputAdornment>
            //   )
            // }}
          />
          {/* <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
            {languages.createTournament.provideDate}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 10, marginTop: 8 }}
          >
            {languages.createTournament.dateDescription}
          </Typography> */}
          <KeyboardDatePicker
            fullWidth
            margin="normal"
            name="date"
            label={
              props.days.length > 0
                ? languages.schedule.day + " 1"
                : languages.createTournament.date
            }
            format={languages.createTournament.dateFormat}
            cancelLabel={languages.createTournament.cancel}
            autoOk={true}
            value={moment
              .unix(props.date)
              .tz(props.timezone || "Europe/Amsterdam")}
            onChange={props.handleDateChange}
            placeholder={languages.createTournament.datePlaceholder}
            invalidLabel={languages.createTournament.invalidDateLabel}
            style={{ marginBottom: 5 }}
            disabled={props.nvdCode !== undefined}
          />
          {props.nvdCode === undefined && (
            <div>
              {props.days
                .sort((a, b) => a.date - b.date)
                .map((day, i) => (
                  <EditDayContainer
                    key={i}
                    tournament={props.tournament}
                    day={day}
                    matches={props.matches || []}
                    new
                    timezone={props.timezone}
                    num={i + 2}
                  />
                ))}
            </div>
          )}
          {props.nvdCode === undefined && (
            <div style={{ marginTop: 10 }}>
              <EditDayContainer
                tournament={props.tournament}
                new
                timezone={props.timezone}
                days={props.days.sort((a, b) => a.date - b.date)}
              />
            </div>
          )}
        </div>
      );
    // case 1:
    //   return (
    //     <div>
    //       {/* <div style={{ textAlign: "center" }}>
    //         <img src={date2} alt="" style={{ height: 120, marginBottom: 20 }} />
    //       </div> */}
    //       {/* <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
    //         {languages.createTournament.provideDate}
    //       </Typography>
    //       <Typography
    //         variant="subtitle1"
    //         style={{ marginBottom: 10, marginTop: 8 }}
    //       >
    //         {languages.createTournament.dateDescription}
    //       </Typography>
    //       <DatePicker
    //         fullWidth
    //         margin="normal"
    //         name="date"
    //         label={
    //           props.days.length > 0
    //             ? languages.schedule.day + " 1"
    //             : languages.createTournament.date
    //         }
    //         format={languages.createTournament.dateFormat}
    //         cancelLabel={languages.createTournament.cancel}
    //         autoOk={true}
    //         keyboard
    //         value={moment.unix(props.date)}
    //         onChange={props.handleDateChange}
    //         placeholder={languages.createTournament.datePlaceholder}
    //         invalidLabel={languages.createTournament.invalidDateLabel}
    //         mask={[/\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
    //         style={{ marginBottom: 5 }}
    //       />
    //       <div>
    //         {props.days
    //           .sort((a, b) => a.date - b.date)
    //           .map((day, i) => (
    //             <EditDayContainer
    //               key={i}
    //               tournament={props.tournament}
    //               day={day}
    //               matches={props.matches || []}
    //               new
    //               num={i + 2}
    //             />
    //           ))}
    //       </div>
    //       <div style={{ marginTop: 10 }}>
    //         <EditDayContainer
    //           tournament={props.tournament}
    //           new
    //           days={props.days.sort((a, b) => a.date - b.date)}
    //         />
    //       </div> */}
    //     </div>
    //   );
    case 1:
      return (
        <div>
          {/* <div style={{ textAlign: "center" }}>
            <img
              src={location3}
              alt=""
              style={{ height: 120, marginBottom: 20 }}
            />
          </div> */}
          <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
            {languages.createTournament.provideLocation}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 10, marginTop: 8 }}
          >
            {languages.createTournament.locationDescription}
          </Typography>
          {/* <TextField
            autoFocus
            margin="dense"
            label={
              props.sportParks.length > 1
                ? languages.schedule.sportPark + " 1"
                : languages.schedule.sportPark
            }
            value={(props.sportParksByKey["0"] || {}).name || ""}
            name="name"
            onChange={props.handleLocationChange}
            type="text"
            fullWidth
            onKeyDown={handleKeyDown}
            // placeholder={languages.createTournament.fillInAndPressEnter}
            style={{ marginTop: 15 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon
                    path={mdiMapMarker}
                    size={1}
                    color="rgba(0, 0, 0, 0.54)"
                    style={{ marginRight: 12 }}
                  />
                </InputAdornment>
              )
            }}
          /> */}
          <LocationAutoComplete
            label={
              props.sportParks.length > 1
                ? languages.schedule.sportPark + " 1"
                : languages.schedule.sportPark
            }
            value={(props.sportParksByKey["0"] || {}).name || ""}
            handleChange={props.handleLocationChange}
            setName={props.setLocationName}
            isDisabled={props.tournament.online || false}
          />
          <div>
            {props.sportParks
              .filter((sportPark) => sportPark.id !== "0")
              .sort((a, b) => Number(a.id) - Number(b.id))
              .map((sportPark, i) => (
                <EditSportParkContainer
                  key={sportPark.id}
                  tournament={props.tournament}
                  sportPark={sportPark}
                  sportParks={props.sportParks}
                  new
                  num={i + 2}
                  isDisabled={props.tournament.online || false}
                  user={props.user}
                  userStatus={props.userStatus}
                  tournamentStatus={props.tournamentStatus}
                />
              ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <EditSportParkContainer
              tournament={props.tournament}
              sportParks={props.sportParks}
              new
              isDisabled={props.tournament.online || false}
              user={props.user}
              userStatus={props.userStatus}
              tournamentStatus={props.tournamentStatus}
            />
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 0,
              marginTop: 15,
            }}
          >
            <FormControlLabel
              style={{ marginRight: 0 }}
              control={
                <Checkbox
                  checked={props.tournament.online || false}
                  onChange={props.handleOnlineCheck}
                  color="primary"
                />
              }
              label={languages.tournament.online}
            />
            <Tooltip
              title={languages.tournament.onlineDescription}
              placement="top"
            >
              <span>
                <IconButton
                  disabled
                  style={{
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                >
                  <HelpIcon
                    style={{
                      height: 17,
                      marginLeft: 5,
                    }}
                  />
                </IconButton>
              </span>
            </Tooltip>
          </div>
        </div>
      );
    case 2:
      return (
        <div>
          {/* <div style={{ textAlign: "center" }}>
            <img
              src={divisions4}
              alt=""
              style={{ height: 120, marginBottom: 20 }}
            />
          </div> */}
          <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
            {languages.createTournament.provideDivision}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 10, marginTop: 8 }}
          >
            {languages.createTournament.divisionsDescription}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            label={
              props.divisions.length > 1
                ? languages.divisions.division + " 1"
                : languages.divisions.division
            }
            value={(props.divisionsObject["0"] || {}).name || ""}
            name="name"
            onChange={props.handleDivisionChange}
            type="text"
            fullWidth
            onKeyDown={handleKeyDown}
            // placeholder={languages.createTournament.fillInAndPressEnter}
            style={{ marginTop: 15 }}
          />
          <div>
            {props.divisions
              .filter((division) => division.id !== "0")
              .sort((a, b) => a.id - b.id)
              .map((division, i) => (
                <EditDivisionContainer
                  key={division.id}
                  tournament={props.tournament}
                  division={division}
                  new
                  num={i + 2}
                  user={props.user}
                  userStatus={props.userStatus}
                  tournamentStatus={props.tournamentStatus}
                />
              ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <EditDivisionContainer
              tournament={props.tournament}
              new
              user={props.user}
              userStatus={props.userStatus}
              tournamentStatus={props.tournamentStatus}
            />
          </div>
        </div>
      );
    case 3:
      return (
        <div>
          {/* <div style={{ textAlign: "center" }}>
            <img
              src={account5}
              alt=""
              style={{ height: 120, marginBottom: 20 }}
            />
          </div> */}
          <Typography style={{ fontSize: 27, fontWeight: "bold" }}>
            {languages.createTournament.registration}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 10, marginTop: 8 }}
          >
            {languages.formatString(
              languages.createTournament.registrationDescription,
              props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
          </Typography>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            name="firstName"
            label={languages.login.firstName}
            value={props.firstName}
            onChange={props.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon
                    path={mdiAccount}
                    size={1}
                    color="rgba(0, 0, 0, 0.54)"
                    style={{ marginRight: 12 }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            type="email"
            name="email"
            margin="dense"
            fullWidth
            label={languages.login.email}
            value={props.email}
            onChange={props.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon
                    path={mdiEmail}
                    size={1}
                    color="rgba(0, 0, 0, 0.54)"
                    style={{ marginRight: 12 }}
                  />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            type="password"
            name="password"
            margin="dense"
            fullWidth
            label={languages.login.password}
            value={props.password}
            onChange={props.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Icon
                    path={mdiLock}
                    size={1}
                    color="rgba(0, 0, 0, 0.54)"
                    style={{ marginRight: 12 }}
                  />
                </InputAdornment>
              ),
            }}
          />
          {/* <TextField
            type="password"
            name="passwordConfirm"
            margin="dense"
            fullWidth
            label={languages.login.passwordConfirm}
            value={props.passwordConfirm}
            onChange={props.handleChange}
          /> */}
          <div style={{ color: "red" }}>{props.errorMessageRegister}</div>
          <Typography variant="caption" style={{ marginTop: 10 }}>
            {languages.login.acceptGeneralTermsMessage + " "}
            <a
              href={languages.misc.generalTermsURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              {languages.login.generalTerms.toLowerCase()}
            </a>
            {"."}
          </Typography>
        </div>
      );
    default:
      return "Uknown stepIndex";
  }
}

class CreateTournamentStepper extends React.Component {
  state = {
    activeStep: 0,
  };

  handleNext = () => {
    let steps = getSteps();
    if (this.props.user.isAnonymous) {
      steps.push(" ");
    }
    if (this.state.activeStep === 0) {
      if (window.firebase.analytics) {
        window.firebase.analytics().logEvent("new_tournament_name_submitted");
      }
      // } else if (this.state.activeStep === 1) {
      //   window.firebase.analytics().logEvent("new_tournament_date_submitted");
    } else if (this.state.activeStep === 1) {
      if (window.firebase.analytics) {
        window.firebase
          .analytics()
          .logEvent("new_tournament_location_submitted");
      }
      if (this.props.sportParks.length === 0) {
        this.props.createDefaultLocation();
      }
    } else if (this.state.activeStep === 2) {
      if (window.firebase.analytics) {
        window.firebase
          .analytics()
          .logEvent("new_tournament_division_submitted");
      }
    }
    if (this.state.activeStep === steps.length - 1) {
      this.props.handleFinish();
    } else {
      this.setState((state) => ({
        activeStep: state.activeStep + 1,
      }));
    }
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      // enter was pressed
      e.preventDefault();
      this.handleNext();
    }
  };

  render() {
    const { classes } = this.props;
    let steps = getSteps();
    if (this.props.user.isAnonymous) {
      steps.push(" ");
    }
    const { activeStep } = this.state;

    const validateStep = {
      0: this.props.tournament.name.length > 0,
      1: true,
      // 2: ((this.props.sportParksByKey["0"] || {}).name || "").length > 0,
      // 3: ((this.props.divisionsObject["0"] || {}).name || "").length > 0,
      2: true,
      3:
        // this.props.nameClubCompany.length > 0 &&
        this.props.email.length > 0 && this.props.password.length > 0,
    };

    return (
      <div className={classes.root}>
        <div
          style={{
            width: "100%",
            // paddingTop: this.props.user.isAnonymous ? 0 : 20
          }}
        >
          <div className={classes.centerContainer}>
            <div
              style={{
                display: "flex",
                margin: "0 auto",
                maxWidth: 900,
                alignItems: "baseline",
                justifyContent: "center",
              }}
            >
              <div style={{ paddingBottom: 20 }}>
                <Paper className={classes.paper}>
                  <LinearProgress
                    variant="determinate"
                    value={(activeStep + 1) * (100 / steps.length)}
                    style={{
                      maxWidth: 400,
                      marginBottom: 30,
                      borderTopLeftRadius: 4,
                      borderTopRightRadius: 4,
                    }}
                  />
                  <div style={{ padding: "0 35px 60px" }}>
                    <div style={{ minHeight: 410 }}>
                      {getStepContent(
                        activeStep,
                        this.props,
                        this.handleKeyDown
                      )}
                    </div>
                    <div
                      style={{
                        marginTop: 10,
                        width: "100%",
                        maxWidth: 330,
                        // position: "absolute",
                        // bottom: 20
                        //   padding: "0 15px",
                        //   background: "white",
                        //   paddingBottom: 10
                      }}
                    >
                      <Button
                        style={{ float: "right" }}
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        disabled={!validateStep[activeStep]}
                      >
                        {activeStep === steps.length - 1
                          ? languages.createTournament.create
                          : languages.createTournament.next}
                      </Button>
                      <Button
                        style={{
                          float: "right",
                          visibility:
                            activeStep === 0 && this.props.user.isAnonymous
                              ? "hidden"
                              : "",
                        }}
                        onClick={
                          activeStep === 0
                            ? this.props.handleBack
                            : this.handleBack
                        }
                        className={classes.backButton}
                      >
                        {activeStep === 0
                          ? languages.createTournament.cancel
                          : languages.createTournament.back}
                      </Button>
                    </div>
                  </div>
                </Paper>
                {this.props.user.isAnonymous && (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "10px 10px 0",
                      zIndex: 10,
                      position: "relative",
                      background: "white",
                      borderRadius: 4,
                      maxWidth: 400,
                      width: "95%",
                    }}
                  >
                    <Typography>
                      {languages.createTournament.alreadyAnAccount + " "}
                      <Link
                        to={
                          this.props.psdCode
                            ? "/login/" + this.props.psdCode
                            : "/"
                        }
                      >
                        {languages.login.login}
                      </Link>
                    </Typography>
                  </div>
                )}
              </div>

              {/* {this.props.user.isAnonymous && (
                <div className={classes.descriptionTexts}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 50,
                    }}
                  >
                    <CheckCircleIcon
                      color="primary"
                      style={{ marginRight: 10 }}
                    />
                    <Typography
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                      }}
                    >
                      {languages.createTournament.onlineSignupDescription}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 50,
                    }}
                  >
                    <CheckCircleIcon
                      color="primary"
                      style={{ marginRight: 10 }}
                    />
                    <Typography
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                      }}
                    >
                      {languages.createTournament.livePageDescription}
                    </Typography>
                  </div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <CheckCircleIcon
                      color="primary"
                      style={{ marginRight: 10 }}
                    />
                    <Typography
                      style={{
                        fontSize: 18,
                        fontWeight: 500,
                      }}
                    >
                      {this.props.nvdCode
                        ? languages.createTournament.nvdDescription
                        : languages.createTournament.numUsersDescription}
                    </Typography>
                  </div>
                </div>
              )} */}
            </div>
          </div>
          {this.props.nvdCode && (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
                position: "fixed",
                bottom: 0,
                zIndex: 1,
              }}
            >
              <img
                src="https://denationalevoetbaldag.nl/assets/images/dividers/divider_8.0@3x.png"
                alt=""
                className={classes.nvd1}
              />
              <img
                src="https://denationalevoetbaldag.nl/assets/images/dividers/divider_8.1@3x.png"
                alt=""
                className={classes.nvd2}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

CreateTournamentStepper.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles, { withTheme: true })(CreateTournamentStepper);
